import {
  BodyMedium,
  BodyMediumEmphasized,
  Dialog,
} from '@/design-system';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { useContext } from 'react';
import UserPreferencesContext from '@/context/UserPreferencesContext';

type Props = {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const CommunityDisclaimerModal: React.FC<Props> = ({
  isOpen,
  onConfirm,
  onCancel,
}) => {
  const { updateUserPreferences } = useContext(UserPreferencesContext);

  const onConfirmClick = async() => {
    await updateUserPreferences({
      disclaimer: {
        version: "1"
      }
    });
    onConfirm();
  }

  return (
    <Dialog
      isOpen={isOpen}
      title="Disclaimer"
      description={
        <>
        <BodyMediumEmphasized>
          Extended community {' '}
        </BodyMediumEmphasized>
        <BodyMedium>
          consists of more opportunities suitable for my child’s grade/age that are distributed through other schools in my local area.
        </BodyMedium>
         <br/> <br/>
         <BodyMedium>
          By selecting continue, I acknowledge I will be viewing flyers that were not distributed through my child's school.
         </BodyMedium>
        </>
      }
      confirmButtonText="Continue"
      onCancel={onCancel}
      onConfirm={onConfirmClick}
    />
  );
}
